import { useMemo } from 'react'

import { useServerRequests } from '~/hooks/useRequests'
import { BackendTransaction } from '~/types'

const createGetTransaction = (
  serverGetRequest: ReturnType<typeof useServerRequests>['serverGetRequest'],
) => {
  return async (transactionId: string): Promise<BackendTransaction> => {
    const result = await serverGetRequest<{
      transaction: BackendTransaction
    }>({
      path: `/api/smart_accounts/transactions/${transactionId}`,
    })

    if (!result?.data) {
      throw new Error('No transaction found')
    }

    return result.data.transaction
  }
}

export const useGetTransaction = (): {
  getTransaction: (transactionId: string) => Promise<BackendTransaction>
} => {
  const { serverGetRequest } = useServerRequests()

  const getTransaction = useMemo(
    () => createGetTransaction(serverGetRequest),
    [serverGetRequest],
  )

  return { getTransaction }
}
